import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { NotificationForm } from "./api";
import { getNotifications } from "./slice";

export const useNotifications = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.notification);
  const dispatch = useAppDispatch();

  const getNotificationsHandler = useCallback(
    (data: NotificationForm) => dispatch(getNotifications({ userId, data })),
    [dispatch, userId]
  );

  return {
    state,
    getNotifications: getNotificationsHandler,
  };
};
